// src/features/kpi/kpiThunk.js

import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { generateConfig } from "../../utils/api";
import { handleApiError } from "../../utils/apiErrorHandler";

export const fetchWaagData = createAsyncThunk(
  "waag/fetchWaagData",
  async (_, { rejectWithValue, getState }) => {
    try {
      const state = getState();
      const token = state.auth.token;
      const { baseURL, config } = generateConfig({ token });

      const response = await axios.get(`${baseURL}/api/waag`, config);
      return response.data;
    } catch (error) {
      return handleApiError(error, rejectWithValue);
    }
  }
);

export const fetchWaagDataByDateRange = createAsyncThunk(
  "waag/fetchWaagDataByDateRange",
  async ({ startDate, endDate }, { rejectWithValue, getState }) => {
    try {
      const state = getState();
      const token = state.auth.token;
      const { baseURL, config } = generateConfig({ token });

      const response = await axios.get(
        `${baseURL}/api/waag/date-range?startDate=${startDate}&endDate=${endDate}`,
        config
      );
      return response.data;
    } catch (error) {
      return handleApiError(error, rejectWithValue );
    }
  }
);

export const fetchOfficeManagerData = createAsyncThunk(
  "kpi/fetchOfficeManagerData",
  async (_, { rejectWithValue, getState }) => {
    try {
      const state = getState();
      const token = state.auth.token;
      const { baseURL, config } = generateConfig({ token });

      const response = await axios.get(
        `${baseURL}/api/waag/office-manager`,
        config
      );

      return response.data;
    } catch (error) {
      return handleApiError(error, rejectWithValue );
    }
  }
);

export const fetchWaagWeeklyData = createAsyncThunk(
  "kpi/fetchWaagWeeklyData",
  async ({ weeks }, { rejectWithValue, getState }) => {
    try {
      const state = getState();
      const token = state.auth.token;
      const { baseURL, config } = generateConfig({ token });

      const response = await axios.get(`${baseURL}/api/waag/weekly`, {
        ...config,
        params: { weeks },
      });

      return response.data;
    } catch (error) {
      return handleApiError(error, rejectWithValue);
    }
  }
);
